import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function PageShell({ eyebrow, title, subtitle, children, hero }) {
  return (
    <main className="relative min-h-screen bg-[#08080b] text-[#e7e5e0] overflow-x-clip">
      <Header />
      <section className="relative pt-32 md:pt-36 pb-10 md:pb-14 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(228,180,78,0.15),transparent_55%)]" />
          <div className="absolute inset-0 opacity-[0.06]"
            style={{
              backgroundImage:
                'linear-gradient(rgba(228,180,78,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(228,180,78,0.4) 1px, transparent 1px)',
              backgroundSize: '80px 80px',
              maskImage: 'radial-gradient(ellipse at center, black 30%, transparent 70%)',
              WebkitMaskImage: 'radial-gradient(ellipse at center, black 30%, transparent 70%)',
            }} />
        </div>
        <div className="relative max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
          {eyebrow && <div className="text-xs font-bold tracking-[0.32em] text-[#e4b44e]/85 mb-3">{eyebrow}</div>}
          <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-black text-white leading-[1.05]">{title}</h1>
          {subtitle && <p className="text-white/60 mt-4 md:mt-5 text-base md:text-lg max-w-2xl">{subtitle}</p>}
          {hero}
        </div>
      </section>
      <div>{children}</div>
      <Footer />
    </main>
  );
}
